import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import InputFile from 'uikit/InputFile';
import Select from 'uikit/Select';

import styles from './Editor.module.scss';

const cx = classNames.bind(styles);

const Editor = ({ className, course, t }) => (
  <>
    <div className={cx('container', className)}>
      <div className={cx('explanation')}>
        <p>{t('questions/PDFOrPPT/explanation')}</p>
      </div>
      <Select
        className={cx('field')}
        icon="book-open"
        label={t('questions/PDFOrPPT/chapter-label')}
        name="chapterId"
      >
        <option value="">{t('questions/PDFOrPPT/no-chapter')}</option>
        {course.chapters.map((chapter) => (
          <option key={chapter.id} value={chapter.id}>
            {chapter.title}
          </option>
        ))}
      </Select>
      <InputFile
        accept=".ppt,.pptx,.pps,.pot,.ppsx,.potx,.odp,.key,.pdf,.apkg"
        label={t('Questions/PDFOrPPT/file-label')}
        name="file"
      />
    </div>
  </>
);

Editor.propTypes = {
  className: PropTypes.string,
  course: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

Editor.defaultProps = {
  className: undefined,
};

export default Editor;
